import './LuckyNumbers.css'
import LuckyRow from './LuckyRow'

export default props => 
    <div className='lucky-numbers'>
        <LuckyRow first='1'></LuckyRow> 
        <LuckyRow first='11'></LuckyRow> 
        <LuckyRow first='21'></LuckyRow> 
        <LuckyRow first='31'></LuckyRow> 
        <LuckyRow first='41'></LuckyRow> 
        <LuckyRow first='51'></LuckyRow> 
        <LuckyRow first='61'></LuckyRow> 
        <LuckyRow first='71'></LuckyRow> 
        <LuckyRow first='81'></LuckyRow> 
        <LuckyRow first='91'></LuckyRow> 
    </div>
